<span [ngClass]="{    
    between: between,
    topSpace: topSpace,
    bottomSpace: bottomSpace,
    topSeparator: topSeparator,
    bottomSeparator: bottomSeparator,
  }"
  class="sports-grid-helper"
>
  <ng-content/>
</span>
